import React from 'react';
import CustomerStatesList from './CustomerStatesList';
import CustomerStatesAdd from './CustomerStatesAdd';

export default function CustomerStatesSettings({ crm_state, type } = {}) {
  if (type === 'add' || type === 'edit') {
    return <CustomerStatesAdd crm_state={crm_state} type={type} />;
  }
  return <CustomerStatesList />;
}
